/* Motor de "Completa tu rutina": elige un producto para cada paso que falta.
   Lo usan la pagina de producto (completa-rutina.js) y el carrito (rutina-carrito.liquid).
   Datos: /collections/bests-sellers/<paso>?view=quiz-json (catalogo vigente, ordenado por mas vendidos). */
(function () {
  if (window.LlRutina) return;

  var PASOS = [
    { tag: 'paso-1-preparacion', n: 1, nombre: 'Limpia', tipo: 'Limpiador' },
    { tag: 'paso-2-tratamiento', n: 2, nombre: 'Trata', tipo: 'Sérum' },
    { tag: 'paso-3-sellado', n: 3, nombre: 'Hidrata', tipo: 'Crema y tratamiento facial' },
    { tag: 'paso-4-proteccion', n: 4, nombre: 'Protege', tipo: 'Protector solar' }
  ];
  var INQUIETUDES = ['manchas', 'melasma', 'acne', 'poros', 'arrugas', 'flacidez', 'deshidratacion', 'opacidad', 'rosacea', 'ojeras', 'anti-envejecimiento', 'despigmentantes'];
  // Inquietudes que marcan un producto especializado (hidratar, poros u opacidad combinan con todo).
  var FUERTES = ['manchas', 'melasma', 'acne', 'arrugas', 'flacidez', 'rosacea', 'anti-envejecimiento', 'despigmentantes'];
  // Productos de nicho: solo se sugieren si lo que ya lleva la persona apunta a eso.
  var NICHO = ['post-procedimiento', 'rosacea'];
  var NUNCA_TIPOS = ['Mascarilla', 'Contorno de ojos', 'Experiencia en clínica', 'Suplemento'];
  var NUNCA_TAGS = ['promocion', 'servicio', 'experiencia-en-clinica', 'sin-descuento'];
  var RX_NO = {
    'paso-1-preparacion': /precleanse|desmaquill|micelar|bif[aá]sic|toallita|exfolia|peel|polish|foliant|\bpads\b|accelerator|acelerador|bruma|t[oó]nico/i,
    'paso-2-tratamiento': /exfolia|peel|accelerator|catalyst/i,
    'paso-3-sellado': /corporal|cuello|escote|bruma|atopeel|cicapost|similcare/i,
    'paso-4-proteccion': /corporal|leche|stick|primer|corrector|bruma|ultra zinc/i
  };

  function handleize(s) {
    return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function preview() {
    var m = /[?&]preview_theme_id=(\d+)/.exec(window.location.search);
    return m ? '&preview_theme_id=' + m[1] : '';
  }
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};

  function traer(pasoTag) {
    if (!cache[pasoTag]) {
      cache[pasoTag] = fetch(raiz + 'collections/bests-sellers/' + pasoTag + '?view=quiz-json' + preview(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : '{"products":[]}'; })
        .then(function (x) { try { return JSON.parse(x).products || []; } catch (e) { return []; } })
        .catch(function () { return []; });
    }
    return cache[pasoTag];
  }

  /* base = { tags: [...], vendors: [...], pasos: ['paso-1-preparacion', ...], excluir: [productId, ...] } */
  function sugerir(base) {
    var tags = (base.tags || []).map(handleize);
    var pieles = tags.filter(function (t) { return t.indexOf('piel-') === 0; });
    var concerns = tags.filter(function (t) { return INQUIETUDES.indexOf(t) > -1; });
    var vendors = (base.vendors || []).map(function (v) { return String(v).toLowerCase(); });
    var excluir = (base.excluir || []).map(String);
    var presentes = (base.pasos || []).map(handleize);

    var faltan = PASOS.filter(function (p) { return presentes.indexOf(p.tag) === -1; });

    return Promise.all(faltan.map(function (paso) {
      return traer(paso.tag).then(function (lista) {
        var total = lista.length || 1;
        var mejor = null;
        lista.forEach(function (p, i) {
          if (excluir.indexOf(String(p.id)) > -1) return;
          if (NUNCA_TIPOS.indexOf(p.type) > -1) return;
          var th = (p.tags || []).map(handleize);
          if (th.some(function (t) { return NUNCA_TAGS.indexOf(t) > -1; })) return;
          if (RX_NO[paso.tag] && RX_NO[paso.tag].test(p.title)) return;

          var s = 0;
          if (p.type === paso.tipo) s += 4;
          if (paso.n === 3 && th.indexOf('hidratantes') > -1) s += 2;
          concerns.forEach(function (q) { if (th.indexOf(q) > -1) s += 4; });
          // Lo que trata el producto y no tiene que ver con lo que buscas resta: evita sugerir antiarrugas para acne.
          th.forEach(function (t) { if (FUERTES.indexOf(t) > -1 && concerns.indexOf(t) === -1) s -= 2; });
          var pielesP = th.filter(function (t) { return t.indexOf('piel-') === 0; });
          if (pieles.some(function (pl) { return pielesP.indexOf(pl) > -1; })) s += 3;
          else if (pieles.length && pielesP.length) s -= 3; // hecho para otro tipo de piel
          if (vendors.indexOf(String(p.vendor || '').toLowerCase()) > -1) s += 2;
          NICHO.forEach(function (n) { if (th.indexOf(n) > -1 && tags.indexOf(n) === -1) s -= 8; });
          s += 2 * (1 - i / total); // lo mas vendido desempata

          if (!mejor || s > mejor.s) mejor = { p: p, s: s };
        });
        return mejor ? { paso: paso, p: mejor.p } : null;
      });
    })).then(function (r) { return r.filter(Boolean); });
  }

  /* Agrega al carrito como lo hace el tema: re-dibuja el cajon y lo abre. */
  function agregar(items) {
    var secciones = new Set();
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: secciones } }));
    var cuerpo = { items: items.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
    if (secciones.size) cuerpo.sections = Array.from(secciones).join(',');

    return fetch(raiz + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'cart');
        return j;
      });
    }).then(function (j) {
      if (!secciones.size) {
        if (window.location.pathname.replace(/\/$/, '').slice(-5) === '/cart') window.location.reload();
        else document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return;
      }
      return fetch(raiz + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        cart.sections = j.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
      });
    });
  }

  function money(c) { return '$' + Math.round(c / 100).toLocaleString('es-CO'); }

  window.LlRutina = { PASOS: PASOS, sugerir: sugerir, agregar: agregar, money: money, handleize: handleize };
})();
